<template>
  <div class="u-input custom-sheba-number-input">
    <label class="u-input-box" :class="{'is-not-valid': !sheba.isValid, 'disabled': disabled}" :style="getStyles">

      <div class="u-input-label-box">
        <div class="u-input-label-box-start"></div>
        <div v-if="labelPlaceholder || label" class="u-input-label-box-center" :class="[labelPosition]">
          <span class="u-input-label text-subtitle" :class="[{'is-focus': sheba.value.toString().length || label, 'text-body-1': labelPosition === 'inside'}]">{{ labelPlaceholder || label }}</span>
        </div>
        <div class="u-input-label-box-end"></div>
      </div>
      <input type="text"
             :class="[{'disabled': disabled}, $vs.rtl ? 'rtl' : 'ltr']"
             @input="handleInputValue"
             @contextmenu="handleContextMenuClicked($event)"
             @keydown.enter="handleKeydownEnter"
             :autocomplete="'new-password'"
             :name="Math.random()"
             :placeholder="placeholder || ''"
             :disabled="disabled"
             v-model="sheba.value">
<!--      <div class="sheba-prefix">IR</div>-->
    </label>
  </div>
</template>

<script>
export default {
  name: 'customShebaNumberInput',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    labelPlaceholder: {
      type: String,
      default: ''
    },
    labelPosition: {
      type: String,
      default: 'outline',
      validator (value) {
        return ['outline', 'outside'].includes(value)
      }
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    setPageChange: {
      type: Boolean,
      default: () => { return true }
    },
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    styles: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      sheba: {
        logo: '',
        value: '',
        isValid: false
      }
    }
  },
  computed: {
    getStyles () {
      const styles = JSON.parse(JSON.stringify(this.styles))
      if (!styles.width) {
        // styles.width = '230px'
      }

      return styles
    }
  },
  created () {
    if (Object.keys(this.value).length) {
      this.initValues()
    }
    if (this.isEmpty) {
      this.validateSheba()
    }
  },
  methods: {
    handleInputValue () {
      this.addSpace()
      this.validateSheba()
      if (this.setPageChange) {
        this.$store.dispatch('setPageChanges')
      }
      this.$emit('input', {
        value: this.sheba.value.toString().replaceAll(' ', ''),
        isValid: this.sheba.isValid,
        logo: this.sheba.logo
      })
    },
    iso7064Mod97_10 (iban) {
      let remainder = iban, block = ''

      while (remainder.length > 2) {
        block = remainder.slice(0, 9)
        remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length)
      }

      return parseInt(remainder, 10) % 97
    },
    validateSheba () {
      const str = `${this.sheba.value.toString().replaceAll(' ', '')}`
      const pattern = this.$u.validator('regex.shaba.pattern')

      if (this.isEmpty && this.sheba.value === '') {
        this.sheba.isValid = true
        return true
      }

      if (!pattern.test(str)) {
        this.sheba.isValid = false
        return false
      }

      this.sheba.isValid = true
      return true
    },
    addSpace () {
      let val = this.sheba.value
      const limit = 36

      val = val.toString()

      if (val[0] === '0') val = val.substr(1, val.length - 1)

      if (limit && val.length > limit) val = val.substr(0, limit)

      val = val.toString().replaceAll(' ', '')


      const arr = []
      if (val.substr(0, 4) !== undefined) arr.push(val.substr(0, 4))

      if (val.substr(4, 4) !== undefined) arr.push(val.substr(4, 4))

      if (val.substr(8, 4) !== undefined) arr.push(val.substr(8, 4))

      if (val.substr(12, 4) !== undefined) arr.push(val.substr(12, 4))

      if (val.substr(16, 4) !== undefined) arr.push(val.substr(16, 4))

      if (val.substr(20, 4) !== undefined) arr.push(val.substr(20, 4))

      if (val.substr(24, 4) !== undefined) arr.push(val.substr(24, 4))

      if (val.substr(28, 4) !== undefined) arr.push(val.substr(28, 4))

      if (val.substr(32, 4) !== undefined) arr.push(val.substr(32, 4))

      if (val.substr(36, 4) !== undefined) arr.push(val.substr(36, 4))

      let copy = ''
      arr.forEach((elm) => {
        if (elm) {
          if (copy) copy += ' '

          copy += elm
        }
      })

      this.sheba.value = copy
    },
    initValues () {
      this.sheba.value = this.value.value
      this.addSpace()
      this.validateSheba()
    },
    handleContextMenuClicked (event) {
      const payload = {
        actions: {
          clipboard: this.sheba.value,
          paste: true
        },
        event
      }
      this.$store.dispatch('helper/contextMenuClicked', payload)
    },
    handleKeydownEnter () {
      this.$emit('pressEnter')
    }
  },
  watch: {
    value: {
      handler () {
        this.initValues()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-sheba-number-input {
  position: relative;

}
</style>
